import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { CommonActions } from '@react-navigation/native';
import DeliveryContact from './DeliveryContact';
import { setDeliveryContact } from '../../../modules/SignUp/DeliveryContact/actions';
import { setDeliveryInstruction } from '../../../modules/SignUp/DeliveryAddress/actions';
import ValidationService from '../../../lib/validation';
import { deliveryMethodSelector } from '../../../modules/SignUp/DeliveryMethod/selectors';
import { deliveryContactSelector } from '../../../modules/SignUp/DeliveryContact/reducer';
import { deliveryInstructionSelector } from '../../../modules/SignUp/DeliveryAddress/reducer';
import Navigation from '../../../lib/navigation';

const validate = values => {
  return {
    name: ValidationService.validateName(values.name),
  };
};

const mapStateToProps = state => ({
  deliveryMethod: deliveryMethodSelector(state),
  initialValues: {
    name: deliveryContactSelector(state).name,
    phoneNumber: deliveryContactSelector(state).phoneNumber,
    deliveryInstruction: deliveryInstructionSelector(state),
  },
});

const mapDispatchToProps = dispatch => ({
  onSubmit: ({ name, phoneNumber, deliveryInstruction }) => {
    dispatch(setDeliveryContact({ name, phoneNumber }));
    dispatch(setDeliveryInstruction(deliveryInstruction));
    Navigation.dispatch(CommonActions.navigate({ name: 'confirmPlan' }));
  },
});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), reduxForm({ form: 'deliveryContact', validate }));
export default enhance(DeliveryContact);
